module.exports = __webpack_public_path__ + "img/86.816c821e.jpg";